import gql from 'graphql-tag';

import type { ImproveContentType } from 'src/data/types';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query RecentlyUsedContentTypes {
    recentlyUsedContentTypes
  }
`;

export const queryRecentlyUsedContentTypes = async () => {
  const { data } = await executeGqlQuery({
    query: QUERY,
  });
  return getSingleProp<ImproveContentType[]>(data) || [];
};
